//其他基本数据接口
import request from '@/utils/request'

// 查询合同信息列表
export function listContractInfo(query) {
  return request({
    url: '/base/contractInfo/list',
    method: 'get',
    params: query
  })
}

// 查询全部合同信息列表
export function listAllContractInfo(query) {
  return request({
    url: '/base/contractInfo/allList',
    method: 'get',
    params: query
  })
}

// 新增合同信息
export function addContractInfo(data) {
  return request({
    url: '/base/contractInfo',
    method: 'post',
    data: data
  })
}


// 修改合同信息
export function updateContractInfo(data) {
  return request({
    url: '/base/contractInfo',
    method: 'put',
    data: data
  })
}

// 删除合同信息
export function delContractInfo(infoId) {
  return request({
    url: '/base/contractInfo/' + infoId,
    method: 'delete'
  })
}

// 查询合同信息详细
export function getContractInfo(infoId) {
  return request({
    url: '/base/contractInfo/' + infoId,
    method: 'get'
  })
}



// 查询款项类别关联关系列表
export function listAllPayCategoryAssociation(query) {
  return request({
    url: '/base/payCategoryAssociation/allList',
    method: 'get',
    params: query
  })
}



// 新增收付款信息
export function addPayInfo(data) {
  return request({
    url: '/base/payInfo',
    method: 'post',
    data: data
  })
}

// 查询收付款信息列表
export function listPayInfo(query) {
  return request({
    url: '/base/payInfo/list',
    method: 'get',
    params: query
  })
}




// 新增证书详细扩展
export function addPayCertificateDetail(data) {
  return request({
    url: '/base/payCertificateDetail',
    method: 'post',
    data: data
  })
}

// 修改证书详细扩展
export function updatePayCertificateDetail(data) {
  return request({
    url: '/base/payCertificateDetail',
    method: 'put',
    data: data
  })
}


// 查询证书详细扩展详细
export function getPayCertificateDetail(infoId) {
  return request({
    url: '/base/payCertificateDetail/' + infoId,
    method: 'get'
  })
}


// 查询证书详细扩展列表
export function listPayCertificateDetail(query) {
  return request({
    url: '/base/payCertificateDetail/list',
    method: 'get',
    params: query
  })
}

// 修改付款信息
export function updatePayInfo(data) {
  return request({
    url: '/base/payInfo',
    method: 'put',
    data: data
  })
}

// 删除付款信息
export function delPayInfo(infoId) {
  return request({
    url: '/base/payInfo/' + infoId,
    method: 'delete'
  })
}


//查询全部的收付款信息
export function listAllPayInfo(query) {
  return request({
    url: '/base/payInfo/allList',
    method: 'get',
    params: query
  })
}

// 申请查看历史数据权限
export function applyView(data) {
  return request({
    url: '/base/payInfo/applyView',
    method: 'post',
    data
  })
}

// 查未审批的查看历史数据申请
export function getPendingViewApplications(params) {
  return request({
    url: '/base/viewApplicationForm/pendingList',
    method: 'get',
    params
  })
}

// 当前用户权限状态（申请历史数据查看）
export function getMyViewPermission(params) {
  return request({
    url: '/base/viewApplicationForm/myPermission',
    method: 'get',
    params
  })
}

// 历史数据查看申请 - 管理端全部列表（支持 applyType/status/applyUserId 筛选）
export function listViewApplicationForm(query) {
  return request({
    url: '/base/viewApplicationForm/adminList',
    method: 'get',
    params: query
  })
}

// 历史数据查看申请 - 审批通过（需 allowedTime）
export function approveViewApplicationForm(data) {
  return request({
    url: '/base/viewApplicationForm/adminApprove',
    method: 'put',
    data
  })
}

// 历史数据查看申请 - 驳回
export function rejectViewApplicationForm(data) {
  return request({
    url: '/base/viewApplicationForm/adminReject',
    method: 'put',
    data
  })
}

//统计信息
export function payStatistics(query) {
  return request({
    url: '/base/payInfo/statistics',
    method: 'get',
    params: query
  })
}

//列表统计信息
export function payOverview(query) {
  return request({
    url: '/base/payInfo/overview',
    method: 'get',
    params: query
  })
}

//账单统计信息
export function paySummary(query) {
  return request({
    url: '/base/payInfo/summary',
    method: 'get',
    params: query
  })
}

//时间范围统计收付款统计
export function timeRangeStatistics(query) {
  return request({
    url: '/base/payInfo/timeRangeStatistics',
    method: 'get',
    params: query
  })
}

// 查询收付款信息详细
export function getPayYearlyStatistics(query) {
  return request({
    url: '/base/payInfo/yearlyStatistics',
    method: 'get',
    params: query
  })
}




// 查询合同累计统计
export function getContractYearlyStatistics(query) {
  return request({
    url: '/base/contractInfo/yearlyStatistics',
    method: 'get',
    params: query
  })
}


// 查询付款累计统计
export function getPayCategoryStatistics(query) {
  return request({
    url: '/base/payInfo/categoryStatistics',
    method: 'get',
    params: query
  })
}


//收款累计统计
export function getReceiptCategoryStatistics(query) {
  return request({
    url: '/base/payInfo/receiptCategoryStatistics',
    method: 'get',
    params: query
  })
}

//累计利润
export function getContractProfitStatistics(query) {
  return request({
    url: '/base/payInfo/contractProfitStatistics',
    method: 'get',
    params: query
  })
}

// 查询合同信息列表
export function listAllNoTableContractInfo(query) {
  return request({
    url: '/base/contractInfo/basicList',
    method: 'get',
    params: query
  })
}

// ====== 请款相关接口 ======

// 获取分管负责人列表
export function getChargeLeaders() {
  return request({
    url: '/base/requestPay/chargeLeaders',
    method: 'get'
  })
}

// 获取用户列表（下拉选择）
export function listAllUser(query) {
  return request({
    url: '/system/user/list',
    method: 'get',
    params: query
  })
}

// 查询请款列表（我的请款）
export function listRequisition(query) {
  return request({
    url: '/base/requestPay/my/list',
    method: 'get',
    params: query
  })
}

// 提交请款（我的）
export function submitRequestPay(data) {
  return request({
    url: '/base/requestPay/my/submit',
    method: 'post',
    data: data
  })
}

// 提交收款（我的）
export function submitReceipt(data) {
  return request({
    url: '/base/requestPay/my/submitReceipt',
    method: 'post',
    data: data
  })
}

// 重新提交（驳回后修改再提交）
export function resubmitRequestPay(data) {
  return request({
    url: '/base/requestPay/my/resubmit',
    method: 'put',
    data: data
  })
}

// 查询请款详情（我的）
export function getRequestPayDetail(rId) {
  return request({
    url: '/base/requestPay/my/' + rId,
    method: 'get'
  })
}

// 分管领导审阅列表（chargeLeaderId = 当前登录用户）
export function listChargeLeaderReview(query) {
  return request({
    url: '/base/requestPay/my/chargeList',
    method: 'get',
    params: query
  })
}

// 分管领导审批通过 flowStatus 1→3
export function approveRequestPay(data) {
  return request({
    url: '/base/requestPay/my/chargeApprove',
    method: 'put',
    data: data
  })
}

// 分管领导驳回 flowStatus 1→2
export function rejectRequestPay(data) {
  return request({
    url: '/base/requestPay/my/chargeReject',
    method: 'put',
    data: data
  })
}

// 关联合同（更新 contractId）
export function linkRequestPayContract(data) {
  return request({
    url: '/base/requestPay/my/linkContract',
    method: 'put',
    data: data
  })
}

// 主管审阅列表（flowStatus = 3 领导审核中）
export function listLeaderReview(query) {
  return request({
    url: '/base/requestPay/my/leaderList',
    method: 'get',
    params: query
  })
}

// 出纳待办列表（cashierId = 当前用户，flowStatus IN 5,6）
export function listCashierReview(query) {
  return request({
    url: '/base/requestPay/my/cashierList',
    method: 'get',
    params: query
  })
}

// 主管审批通过 flowStatus 3→5
export function leaderApproveRequestPay(data) {
  return request({
    url: '/base/requestPay/my/leaderApprove',
    method: 'put',
    data: data
  })
}

// 确认收款入库（收款 flowStatus 3→完成）
export function confirmReceiptRequest(data) {
  return request({
    url: '/base/requestPay/my/confirmReceipt',
    method: 'put',
    data: data
  })
}

// 主管驳回 flowStatus 3→4
export function leaderRejectRequestPay(data) {
  return request({
    url: '/base/requestPay/my/leaderReject',
    method: 'put',
    data: data
  })
}

// 获取出纳人员列表
export function getCashierList() {
  return request({
    url: '/base/requestPay/cashiers',
    method: 'get'
  })
}

// 主管确认请款（选择出纳，flowStatus 3→5）
export function leaderConfirmRequestPay(data) {
  return request({
    url: '/base/requestPay/my/leaderConfirm',
    method: 'put',
    data: data
  })
}

// 确认付款（flowStatus 5→6）
export function confirmPayRequest(data) {
  return request({
    url: '/base/requestPay/my/confirmPay',
    method: 'put',
    data: data
  })
}

// 出纳退回（flowStatus 5→ 驳回/退回状态）
export function cashierReturnRequest(data) {
  return request({
    url: '/base/requestPay/my/cashierReturn',
    method: 'put',
    data: data
  })
}

// 付款人统计（按付款日期/付款人统计笔数和金额）
export function getPayerStats(params) {
  return request({
    url: '/base/requestPay/my/payerStats',
    method: 'get',
    params: params
  })
}

// 修改请款
export function updateRequisition(data) {
  return request({
    url: '/base/requisition',
    method: 'put',
    data: data
  })
}

// 删除请款
export function delRequisition(infoId) {
  return request({
    url: '/base/requisition/' + infoId,
    method: 'delete'
  })
}

// 查询请款详情
export function getRequisition(infoId) {
  return request({
    url: '/base/requisition/' + infoId,
    method: 'get'
  })
}

// ====== 收款相关接口 ======

// 查询收款列表
export function listReceipt(query) {
  return request({
    url: '/base/receipt/list',
    method: 'get',
    params: query
  })
}

// 新增收款
export function addReceipt(data) {
  return request({
    url: '/base/receipt',
    method: 'post',
    data: data
  })
}

// 修改收款
export function updateReceipt(data) {
  return request({
    url: '/base/receipt',
    method: 'put',
    data: data
  })
}

// 删除收款
export function delReceipt(infoId) {
  return request({
    url: '/base/receipt/' + infoId,
    method: 'delete'
  })
}

// 查询收款详情
export function getReceipt(infoId) {
  return request({
    url: '/base/receipt/' + infoId,
    method: 'get'
  })
}

// ====== 审阅核查接口 ======

// 获取待审批数量（主管待审核，flowStatus=3）
export function getAuditPendingCount() {
  return request({
    url: '/base/requestPay/my/pendingCount',
    method: 'get'
  })
}

